import { useQuery } from '@tanstack/react-query';

import { SECTION } from 'src/constants/section';
import type { components } from 'src/types/allApiTypes.gen';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

export const POTENTIAL_FOLLOW_UP_OWNERS_PAGINATION_LIMIT = 10;

// Workaround since the API returns snake_case keys even though the generated types are camelCase
export type PaginatedFollowUpOwnersList =
  components['schemas']['PaginatedFollowUpOwnerListList'];

export const usePotentialFollowUpOwners = ({
  search,
  orgUnitIds,
}: {
  search: string;
  orgUnitIds?: Array<number>;
}) =>
  useQuery<PaginatedFollowUpOwnersList>({
    queryKey: [apiPaths.MY_FOLLOW_UP.POTENTIAL_OWNERS, search, orgUnitIds],
    enabled: !!orgUnitIds && orgUnitIds.length > 0,
    queryFn: ({ signal }) =>
      HttpService.get(
        apiPaths.MY_FOLLOW_UP.POTENTIAL_OWNERS,
        {
          org_unit: orgUnitIds?.toString(),
          module_type: SECTION.FOLLOW_UP_ACTION,
          limit: POTENTIAL_FOLLOW_UP_OWNERS_PAGINATION_LIMIT,
          search,
        },
        true,
        { signal },
      )
        .then(({ data }) => Promise.resolve(data))
        .catch(({ response }) => Promise.reject(response)),
    keepPreviousData: true,
  });
